var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', [_vm.status === 'saving' ? _c('span', [_vm._v("(儲存中...)")]) : _vm.status === 'saved' ? _c('span', [_vm._v("(已儲存)")]) : _vm.status === 'failed' ? _c('span', [_vm._v("(儲存失敗)")]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }